import React, { useState } from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  TextField,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

import { AggregateStrategy } from '../../../../../types/aggregateStrategy';
import { Option } from '../../../../../types/option';
import { Nullable } from '../../../../../utils/types';
import { useMakeChild } from '../../hooks/useMakeChild';

type MakeChildProps = {
  strategyId: string;
  options: Option[];
  parentStrategy?: AggregateStrategy;
};

export const MakeChildOfStrategy: React.FC<MakeChildProps> = ({ strategyId, options, parentStrategy }) => {
  const [makeChild, setMakeChild] = useState<boolean>(!parentStrategy);

  const defaultOption = parentStrategy ? { id: parentStrategy.id, name: parentStrategy.name } : undefined;
  const [parentId, setParentId] = useState<Nullable<string>>(defaultOption?.id ?? null);
  const [useSignals, setUseSignals] = useState<boolean>(false);

  const { loading, makeChildOfHandler } = useMakeChild(strategyId, () => setMakeChild(false));

  return (
    <Card>
      <CardHeader title="Перевод в дочернюю к стратегии" />
      <Divider />
      <CardContent>
        <Stack spacing={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={useSignals}
                onChange={(e) => setUseSignals(e.target.checked)}
                disabled={!makeChild}
                inputProps={{ 'aria-label': 'Использовать собственные сигналы на графике' }}
              />
            }
            label="Использовать собственные сигналы на графике"
          />

          <Autocomplete
            disablePortal
            disabled={!makeChild || !!defaultOption}
            options={options}
            value={defaultOption || options.find((o) => o.id === parentId) || null}
            onChange={(_, option) => setParentId(option?.id ?? null)}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) => (
              <TextField {...params} label="Родительская стратегия" placeholder="Родительская стратегия" />
            )}
          />

          <Box>
            <Button
              variant="contained"
              disabled={!parentId || !makeChild || loading}
              onClick={() => makeChildOfHandler(parentId, useSignals)}
              aria-label="Сделать дочерней"
            >
              Сделать дочерней
            </Button>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};
